<template>
<div class="chapter">
<div class="inner_page">
<p><br/></p>
<div class="sgc-2"></div>
<h1 class="c1 sigil_not_in_toc" id="pgepubid00000">In The Reign of Terror</h1>
<h2 class="c2 sigil_not_in_toc" id="pgepubid00001">The Adventures of a Westminster Boy</h2>
<p><br/></p>
<h3 class="c3 sigil_not_in_toc" id="pgepubid00002">by</h3>
<h2 class="c2 sigil_not_in_toc" id="pgepubid00003">G. A. Henty</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// main.vue?64e9c5f4